// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"EcItemFab_componentStyle___jwNs","leftContainer":"EcItemFab_leftContainer__vR60s"};